
export const ORGANISATIONS_LIST = `/mobile/organisations-list/{userId}`;
export const ORGANISATION_REPORT = `/mobile/api/web-raport/`;
export const ORGANISATION_MEMBERS = `/easeetask/assignee-list/`;
export const ORGANISATION_TAGS = `/mobile/organisations-tags/`;
export const ORGANISATION_ADD_TAG = `/mobile/add-organisationTag`;
export const ORGANISATION_ADDFORM = `/easeetask/task/add-form/59/`;
export const ORGANISATION_SUBSCRIPTION = `/mobile/dailee/user_subscription/create_subscription_intent`;
export const ORGANISATION_UPDATE_DEFAULT = `/mobile/update-default/{organisationId}/{userId}`;
export const ORGANISATION_SEARCH_BY_DOMAIN = `/mobile/organisation/search_by_domain`;
export const ORGANISATION_TIMESHEETS_EXPORT = `/mobile/organisation/timesheets_export`;
export const ORGANISATION_PRESENCE_EXPORT = `/mobile/organisation/start_activity_export`;
